module.exports = __webpack_public_path__ + "static/img/logo.347a73f0.png";